export type BansErrorKind = 'auth' | 'network' | 'generic';

/** Map any failure from the bans API to a kind the UI can show as plain copy. Never exposes raw API text. */
export function classifyBansError(err: unknown): BansErrorKind {
  const e = err as { status?: number; message?: unknown; name?: string } | null | undefined;
  const msg = String(e?.message ?? err ?? '');
  const status = typeof e?.status === 'number'
    ? e.status
    : Number(/^API (\d{3})\b/.exec(msg)?.[1] ?? /\((\d{3})\)/.exec(msg)?.[1] ?? 0);
  if (status === 401 || status === 403) return 'auth';
  if (/unauthori[sz]ed|session[ _]expired|forbidden/i.test(msg)) return 'auth';
  if (e?.name === 'TypeError' || e?.name === 'AbortError') return 'network';
  if (/failed to fetch|network|load failed|timed out|offline/i.test(msg)) return 'network';
  return 'generic';
}

export function bansHttpError(message: string, status: number): Error {
  return Object.assign(new Error(message), { status });
}
